import { useState, useLayoutEffect, useRef } from "react"

export const useWindowWidth = () => {
	const [width, set] = useState(0)
	const ref = useRef<HTMLDivElement | null>(null)

	useLayoutEffect(() => {
		// Use a hidden element + ResizeObserver to track viewport width
		// instead of window.resize, which conflicts with Playwright's
		// Emulation.setDeviceMetricsOverride during fullPage screenshots.
		const el = document.createElement("div")
		el.style.cssText =
			"position:fixed;top:0;left:0;width:100vw;height:0;pointer-events:none;visibility:hidden"
		document.body.appendChild(el)
		ref.current = el

		set(el.offsetWidth)

		const observer = new ResizeObserver(() => {
			set(el.offsetWidth)
		})
		observer.observe(el)

		return () => {
			observer.disconnect()
			el.remove()
		}
	}, [])

	return width
}
